export default __webpack_public_path__ + "static/1-0b756590c7067bda20feabda1c077659.jpg";